import styled from 'foundations-theming/utils';

/*
 * foundations' transitional Alert renders its children inside a shrink-to-fit
 * flex item: the internal `ChildrenWrapper` has `flex: 0 1 auto` and only
 * `max-width: 100%`, so it collapses to the width of its content. A
 * `justify-content: space-between` row therefore only spans the full alert
 * width when the description is long enough to reach that `max-width: 100%`.
 * For a short (single-line) description the wrapper collapses to
 * `text + button` width and the CTA trails the text instead of pinning to the
 * right edge (foundations documents this "buttons trail text" behavior as
 * intended for Alerts).
 *
 * This wrapper forces that internal children container to span the full alert
 * width so the CTA always sits at the far right regardless of description
 * length. The selector is coupled to the Alert DOM
 * (`[role="alert"]` > title/children row > children container); if foundations
 * ever changes that structure the selector simply stops matching and the layout
 * reverts to the default trailing behavior rather than breaking.
 */
export const FullWidthAlertContent = styled.div.withConfig({
  displayName: "FullWidthAlertContent"
})({
  '& > [role="alert"] > div > div:last-child': {
    width: '100%'
  }
});